
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, } from '@material-ui/core';
import MSectionHeader from '../../view/MSectionHeader';
import { MatchLeagueItemDay } from '.';

class MatchLeagueContentDay extends React.Component {


    render() {
        const { classes, data } = this.props;
        return (
            <Grid>
                <MSectionHeader title={this.props.title} subtitle='' chevron={false} />
                <Grid container direction='row' spacing={1} className={classes.root}>
                    {
                        data.map((item, i) => (
                            <Grid key={i} item xs={3} className={classes.list}>
                                <MatchLeagueItemDay data={item} />
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(0, 1, 0, 1)
    },
    list: {
        padding: theme.spacing(0, 0.5, 0, 0.5)
    },

}))(MatchLeagueContentDay));